module.exports = __webpack_public_path__ + "static/media/ic-actions-add-simple.9feea127.svg";